import {
  Box,
  CircularProgress,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";

const SelectPlatform = ({
  selectedPlatforms,
  selectedPlatform,
  setSelectedPlatform,
}) => {
  const handleChange = (e) => {
    setSelectedPlatform(e.target.value);
  };
  return (
    <Box sx={{ flexGrow: 1, px: { xs: 3, md: 4 }, pt: { xs: 2, md: 4 } }}>
      {selectedPlatforms === null ? (
        <Box sx={{ textAlign: "center" }}>
          <CircularProgress />
        </Box>
      ) : (
        <Grid
          container
          spacing={{ xs: 2, md: 3 }}
          columns={{ xs: 4 }}
          alignItems="flex-start"
        >
          <Grid item width={{xs: "220px", md: "300px"}}>
            <Box>
              <Typography
                sx={{
                  px: 1,
                  mt: 2,
                }} variant="h3">Choose your platform</Typography>
            </Box>
          </Grid>
          <Grid item xs={2}>
            <Box sx={{ minWidth: 220, maxWidth: 400 }}>
              <FormControl fullWidth variant="outlined" color="info">
                <InputLabel id="select-platform">Select your platform</InputLabel>
                <Select
                  labelId="select-platform"
                  id="select-platform"
                  value={selectedPlatform}
                  label="Select your platform"
                  onChange={handleChange}
                >
                  {selectedPlatforms?.map((platform, index) => platform.active && (
                    <MenuItem key={index} value={platform.name}>
                      {platform.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>
          </Grid>
        </Grid>
      )}
    </Box>
  );
};

export default SelectPlatform;
